module.exports = "/images/icon_loud01_sp.png?82dbbd63930d83d8d0b1a3bc61c14ff0";